/*
 * Public API Surface of ngx-neo-modal-mat
 */

export * from './lib/ngx-neo-modal-mat.service';
export * from './lib/ngx-neo-modal-mat.component';
export * from './lib/ngx-neo-modal-mat.module';
